// This file contains compile-time defined variables.

export const NAME: string = "@shockpkg/dir-projector";

export const VERSION: string = "2.2.2";
